<template>
  <!-- 製品単価グループ保守照会画面 -->
  <div>
    <!-- ●●●上部メニュー●●● -->
    <Header :type="menu_type" :title="title" />
    <div class="container-fluid px-4 py-4 min-vh-85">
      <div class="row d-flex justify-content-center mt-2 mb-2">
        <div class="col-md-12">
          <div class="media">
            <div class="media-body pb-3">
              <div class="d-flex justify-content-between">
                <h5 class="text-secondary m-0"><span class="oi oi-brush"></span><strong> 製品単価グループ保守照会</strong></h5>
                <router-link to="/products-prices-groups-maintenance" class="btn btn-cancel m-0">
                  <span class="oi oi-circle-x"></span> キャンセル
                </router-link>
              </div>
            </div>
          </div>
          <div class="main-card mb-3 card">
            <div class="card-header">
              <b-alert show variant="success" class="mt-2" v-if="successMessages.length">
                <ul v-for="(message, index) in successMessages" :key="index" style="list-style: none;">
                  <li>{{ message }}</li>
                </ul>
              </b-alert>
              <div class="alert alert-danger" role="alert" v-if="errorMessages.length">
                <ul v-for="(message, index) in errorMessages" :key="index" style="list-style: none;">
                  <li>{{ message }}</li>
                </ul>
              </div>
            </div>
            <div class="card-body">
              <div class="row mt-2">
                <!-- 代表コード -->
                <div class="col-12 form-group">
                  <label for="group_product_id" class="form-label">
                    <h5>
                      <strong>
                      代表コード: &nbsp;
                        {{productPricesGroupsObj.group_product_id}}&nbsp;&nbsp;&nbsp;&nbsp; 
                        {{productPricesGroupsObj.group_product_name_kanji}}
                      </strong>
                    </h5>
                  </label>
                </div>
              </div>
              <!-- グループテーブル -->
              <div class="row mt-2">
                <div class="col-10 form-group">
                  <b-table
                    show-empty
                    :head-variant="headVariant"
                    :responsive="true"
                    :items="productPricesGroupsObj.pricesGroups"
                    :fields="fields"
                    :busy="busy"
                    :bordered="true"
                    :empty-text="emptyText"
                  >
                    <!-- テーブル読み込み時表示html -->
                    <template #table-busy>
                      <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>読み込んでいます...</strong>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
              <!-- 削除・編集ボタン -->
              <div class="card-footer">
                <div class="row justify-content-md-center pb-4">
                  <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-xxl-2">
                    <button type="button" class="btn btn-cancel btn-block" @click="clickDeleteBtn(productPricesGroupsObj)"><span class="oi oi-circle-x"></span> 削除</button>
                  </div>
                  <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2 col-xxl-2">
                   <button type="button" class="btn btn-primary btn-block" @click="clickEditBtn"><span class="oi oi-circle-check"></span> 編集</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ●●●フッター●●● -->
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/navigation/header.vue';
import Footer from '@/components/navigation/footer.vue';
import { API, graphqlOperation } from 'aws-amplify';
import { executeTransactSql } from '@/graphql/mutations';
import DataTblDef from '@/assets/js/dataTableDef.js';
import { addOperationLogs, init, isSystemEditable } from '@/assets/js/common.js';
import { DISP_MESSAGES } from '@/assets/js/messages';

// ログ出力用モジュール名
const MODULE_NAME = 'products-prices-groups-inquiry';

export default {
  name: 'PRODUCTS-PRICES-GROUPS-INQUIRY',
  /** コンポーネント */
  components: {
    Header,
    Footer,
  },
  /** データ */
  data() {
    return {
      // ヘッダ
      menu_type: 'user',
      title: '製品単価グループ保守照会',
      busy: false,
      // テーブルのヘッダー色
      headVariant:DataTblDef.headerVariant,
      // 検索結果が0件の場合の表示メッセージ
      emptyText:DataTblDef.emptyText,
      // 製品単価グループ対象
      productPricesGroupsObj: {},
      // グループテーブル
      fields: [
        {
          key: 'member_product_id',
          label: '製品コード',
          thStyle: 'width: 20%;',
          sortable: true
        },
        {
          key: 'member_product_name_kanji',
          label: '製品名',
          thStyle: 'width: 80%;',
          sortable: true
        },
      ],
      // 処理結果成功メッセージ
      successMessages: [],
      // 処理結果エラーメッセージ
      errorMessages: []
    }
  },
  /**
   * beforeMountライフサイクルフック
   */
  async beforeMount() {
    // 新規か編集画面から成功メッセージ
    this.successMessages = this.$route.params.successMessages || []
    await this.fetchData(this.$route.query);
    this.$store.commit('setLoading', false);
  },
  /**
   * mountedライフサイクルフック
   */
  mounted() {
    init(); // common.jsにて初期化処理
    scrollTo(0,0);
  },
  methods:{
    /**
     * 画面に表示するデータを取得します。
     * @param {String} id - 製品コード
     */
    async fetchData({group_product_id}) {
      this.busy = true;
      // 製品単価グループ検索SQL
      const product_group_id = Number(group_product_id)
      // 製品単価グループのデータを請求
      const productPricesGroups = await this.searchPricesGroups(product_group_id)
      // 製品単価グループデータをセット
      const groupProducts = {
        group_product_id: productPricesGroups[0].group_product_id,
        group_product_name_kanji: productPricesGroups[0].group_product_name_kanji,
      }
      groupProducts.pricesGroups = productPricesGroups
      this.productPricesGroupsObj = {...groupProducts}
      this.busy = false;
    },
    /**
     *  製品単価グループマスタを検索します。
     * @param {Int} product_group_id - 代表製品コード
     * @returns {Array<Object>} 製品単価グループマスタデータ
     */
    async searchPricesGroups(product_group_id) {
      const functionName = 'searchPricesGroups';

      let result = null;
      const SQLs = `SELECT 
                  MPPG.product_group_id group_product_id,
                  MP.product_name_kanji group_product_name_kanji,
                  MPPG.product_id member_product_id,
                  MP2.product_name_kanji member_product_name_kanji
                  FROM m_products_prices_groups MPPG 
                  LEFT JOIN m_products MP ON MPPG.product_group_id = MP.product_id 
                  LEFT JOIN m_products MP2 ON  MPPG.product_id = MP2.product_id
                  WHERE MPPG.product_group_id=${product_group_id}`;
      try {
        result = await API.graphql(graphqlOperation(executeTransactSql, { SQLs }))
      } catch (error) {
        await addOperationLogs('Error', MODULE_NAME, functionName, {
          graphqlOperation: 'executeTransactSql',
          SQLs: SQLs
        }, error);
        this.errorMessages.push(DISP_MESSAGES.WARNING['2003']);
        return;
      }
      if (result.errors) {
        await addOperationLogs('Error', MODULE_NAME, functionName, {
          graphqlOperation: 'executeTransactSql',
          SQLs: SQLs,
          result: result
        });
        this.errorMessages.push(DISP_MESSAGES.WARNING['2003']);
        return;
      }
      const body = JSON.parse(result.data.executeTransactSql.body);
      let logLevel = 'Info';
      if (body.error) {
        logLevel = 'Error';
        this.errorMessages.push(DISP_MESSAGES.WARNING['2003']);
      }
      await addOperationLogs(logLevel, MODULE_NAME, functionName, {
        graphqlOperation: 'executeTransactSql',
        SQLs: SQLs,
        'result.data.executeTransactSql': {
          statusCode: result.data.executeTransactSql.statusCode,
          body: body
        }
      });
      return body.data[0]
    },
    /**
     * 編集ボタンの押下
     */
    async clickEditBtn() {
      this.$router.push({ 
        name: 'PRODUCTS-PRICES-GROUPS-EDIT', 
        query: { 
          group_product_id: this.productPricesGroupsObj.group_product_id,
        },
      });
    },
    /**
     * 削除ボタン押下時
     * @param {Object} obj - 製品単価グループ対象
     */
    clickDeleteBtn(obj) {
      this.$bvModal.msgBoxConfirm('製品単価グループデータを削除します。\nよろしいですか？').then(async value => {
        if (value) {
          this.$store.commit('setLoading', true);
          this.successMessages = [];
          this.errorMessages = [];
          await this.execDelPricesGroups(obj)
          if (this.errorMessages.length === 0) {
            this.$router.push({ 
              name: 'PRODUCTS-PRICES-GROUPS-MAINTENANCE',
              params: { successMessages: [DISP_MESSAGES.SUCCESS['1002']] }  
            });
          }
          this.$store.commit('setLoading', false);
        }
      });
    },
    /**
     * 削除処理
     * @param {Int} group_product_id - 選択された代表製品コード
     */
    async execDelPricesGroups({group_product_id}) {
      const functionName = 'execDelPricesGroups';
      // 製品単位変換マスタ
      const SQLs = `DELETE FROM m_products_prices_groups WHERE product_group_id = ${group_product_id}`

      // 月次更新・取引先コード切替・製品コード切替などが実行中かどうかを確認します。
      try {
        const msg = await isSystemEditable();
        if (msg !== null) {
          this.errorMessages.push(msg);
          return;
        }
      } catch (error) {
        await addOperationLogs('Error', MODULE_NAME, functionName, '予期しないエラーが発生しました。', error);
        this.errorMessages.push(DISP_MESSAGES.DANGER['3002']);
        return;
      }

      let result = null;
      try {
        result = await API.graphql(graphqlOperation(executeTransactSql, { SQLs }));
      } catch (error) {
        await addOperationLogs('Error', MODULE_NAME, functionName, {
          graphqlOperation: 'executeTransactSql',
          SQLs: SQLs
        }, error);
        this.errorMessages.push(DISP_MESSAGES.DANGER['3002']);
        return;
      }
      if (result.errors) {
        await addOperationLogs('Error', MODULE_NAME, functionName, {
          graphqlOperation: 'executeTransactSql',
          SQLs: SQLs,
          result: result
        });
        this.errorMessages.push(DISP_MESSAGES.DANGER['3002']);
        return;
      }
      const body = JSON.parse(result.data.executeTransactSql.body);
      let logLevel = 'Info';
      if (body.error) {
        logLevel = 'Error';
        this.errorMessages.push(DISP_MESSAGES.DANGER['3002']);
      }
      await addOperationLogs(logLevel, MODULE_NAME, functionName, {
        graphqlOperation: 'executeTransactSql',
        SQLs: SQLs,
        'result.data.executeTransactSql': {
          statusCode: result.data.executeTransactSql.statusCode,
          body: body
        }
      });
    },
  }
}
</script>